import rawAxios from "axios";
import axios from "@/libs/api.request.js";
import { getInvoiceGameBaseURL } from "@/apis/invoiceCenterPlatform";

const SESSION_PARAM = "invoice_session";

const unwrap = response => {
  const body = response && response.content ? response.content : response;
  if (!body || body.code !== 200) {
    const error = new Error((body && (body.message || body.msg)) || "请求失败");
    error.code = body && body.code;
    error.data = body && body.data;
    return Promise.reject(error);
  }
  return body.data;
};
const gameRequest = (url, options = {}) =>
  axios.request({
    baseURL: getInvoiceGameBaseURL(),
    url,
    unHint: true,
    ...options,
  }).then(unwrap);

export const getInvoiceBootstrap = session =>
  gameRequest("/invoice/consumer/bootstrap", {
    method: "get",
    params: { [SESSION_PARAM]: session },
  });

export const getInvoiceOrders = (session, params) =>
  gameRequest("/invoice/consumer/orders", {
    method: "get",
    params: { ...params, [SESSION_PARAM]: session },
  });

export const getInvoiceRecords = (session, params) =>
  gameRequest("/invoice/consumer/records", {
    method: "get",
    params: { ...params, [SESSION_PARAM]: session },
  });

export const getInvoiceRecordDetail = (session, requestNo) =>
  gameRequest("/invoice/consumer/records/" + encodeURIComponent(requestNo), {
    method: "get",
    params: { [SESSION_PARAM]: session },
  });

export const createInvoiceApplication = (session, data) =>
  gameRequest("/invoice/consumer/applications", {
    data: { ...data, [SESSION_PARAM]: session },
  });

export const getInvoiceApplicationByClient = (session, clientRequestId) =>
  gameRequest("/invoice/consumer/applications/by-client-request/" + encodeURIComponent(clientRequestId), {
    method: "get",
    params: { [SESSION_PARAM]: session },
  });

export const uploadInvoiceProof = (session, formData, onUploadProgress) => {
  const baseURL = process.env.VUE_APP_WORKSN_API;
  if (!baseURL) return Promise.reject(new Error("未配置开票上传服务"));
  formData.append(SESSION_PARAM, session);
  return rawAxios({
    baseURL,
    url: "/api/v1/invoice/consumer/proof-uploads",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
  }).then(response => unwrap(response.data));
};
